<template>
  <v-autocomplete
    @input="(val) => $emit('input', val)"
    :items="items"
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    box
    hide-details
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['value', 'items'],
  data: () => ({}),
  watch: {},
  methods: {},
}
</script>
